<template>
  <div class="address-info">
    <div class="title">Código IMEI del dispositivo nuevo</div>
    <take-pictures
      :is-first.sync="isFirstTakePhoto"
      @delete="deleteImg($event, 'imei')"
      @afterRead="afterReadUploadFile($event, 'imei')"
      @takePhoto="takePhoto($event, 'imei')"
      :list="imeiList">
    </take-pictures>
  </div>                                                                                                                                                                                  
</template>

<script>
const takePictures = () => import("@/components/takePictures.vue");
import { policyPutUpload, uploadImg } from "@/services/api/uploadImg.js"
export default {
  name: "imeiPhoto",
  props: {
    info: Object
  },
  components: {
    takePictures
  },
  data () {
    return {
      isFirstTakePhoto: true,
      commitIdList: [],
      imeiList:[
        {
          key: "imeiImg",
          maxCount: 1,
          // titleDesc: "请在拨号盘输入“*#06#”并清晰拍摄",
          staticImg: require('../../../assets/image/settleAccount/photocasescansmallImei.png'),
          staticSmallImg: require('../../../assets/image/settleAccount/photoCaseImei.png'),
          staticBigImg: require('../../../assets/image/settleAccount/photocasescanImei.png'),
          preImg: "",
          fileId: null,
          status: 0,
        }
      ],
      url: ''
    }
  },
  methods: {
    deleteImg () {
      this.$emit('changeImeiPhoto', false)
    },
    // 调用服务器上传
    afterReadUploadFile(params, type) {
      // debugger
      // 判断type的类型，数字则为浏览器，字符串为webview
      // debugger
      const { file, key, status } = params;
      const data = {
        realName: "1",
        authority: "public-read",
        time: Date.now(),
      };
      policyPutUpload(data).then((res) => {
        let { code, data } = res
        if (code === "0000") {
          let {
            host,
            authority,
            dir,
            policy,
            accessid,
            callback,
            signature,
          } = data;
          let actionUrl = host;
          let imgName = Date.now() + ".jpg";
          let uploadData = {};
          uploadData.name = imgName;
          uploadData["x-oss-object-acl"] = "public-read";
          uploadData.key = dir + imgName;
          uploadData.policy = policy;
          uploadData.OSSAccessKeyId = accessid;
          uploadData.success_action_status = 200;
          uploadData.callback = callback;
          uploadData.signature = signature;
          const dataParams = { key, type };
          if (this.$isOpenInWebview) {
            this.dsBridgeUploadImageToServer(actionUrl, uploadData, dataParams, params.uploadCallback) // 加个params.uploadCallback
          } else {
            this.handleRequestStatus(key, type, 1);
            this.uploadImgApi(file, actionUrl, uploadData, dataParams, params.uploadCallback); // 加个params.uploadCallback
          }
          // params.uploadCallback && params.uploadCallback(true)
        } else {
          // 上传失败
          this.handleRequestStatus(key, type, 3);
          params.uploadCallback && params.uploadCallback(false)
        }
      })
      .catch((res) => {
        // debugger
        this.handleRequestStatus(key, type, 3);
        params.uploadCallback && params.uploadCallback(false)
      });
    },
    takePhoto () {},
    // 处理请求状态
    handleRequestStatus(key, type, targetStatus, objParams = {}) {
      let { fileId, preImg } = objParams;
      if(this.$isOpenInWebview){ // 只有上传成功的
        if(targetStatus == 2){
          if (type === "params") {
              const statusIndex = this.paramsList[0].children.findIndex(
                (item) => item.key === key
              );
              // status 0到1直接push， 3到1为修改
              if (statusIndex > -1) {
                this.paramsList[0].children[statusIndex].status = 1;
              } else {
                this.paramsList[0].children.push({
                  status: 1,
                  key,
                  type,
                  fileId,
                  preImg,
                });
              }
              if (this.paramsList[0] && this.paramsList[0].children) {
                const paramsIndex = this.paramsList[0].children.findIndex(
                  (item) => item.key === key
                );
                try {
                  this.paramsList[0].children[paramsIndex].status = targetStatus;
                  this.paramsList[0].children[paramsIndex].fileId = fileId;
                  this.paramsList[0].children[paramsIndex].preImg = preImg;
                } catch (error) {
                }
              }
          } else {
            this[type + "List"].map((item) => {
              if (item.key === key) {
                item.status = targetStatus;
                item.fileId = fileId;
                item.preImg = preImg;
              }
              return item;
            });
          }
        }
        return
			}
      // debugger
      if (type === "params") {
        if (targetStatus === 1) {
          const statusIndex = this.paramsList[0].children.findIndex(
            (item) => item.key === key
          );
          // status 0到1直接push， 3到1为修改
          if(this.paramsList && this.paramsList.length > 0){
            if (statusIndex > -1) {
              this.paramsList[0].children[statusIndex].status = 1;
            } else {
              this.paramsList[0].children.push({
                status: 1,
                key,
                type,
                fileId,
                preImg,
              });
            }
          }
        } else {
          if (this.paramsList[0] && this.paramsList[0].children) {
            const paramsIndex = this.paramsList[0].children.findIndex(
              (item) => item.key === key
            );
            try {
              this.paramsList[0].children[paramsIndex].status = targetStatus;
              this.paramsList[0].children[paramsIndex].fileId = fileId;
              this.paramsList[0].children[paramsIndex].preImg = preImg;
            } catch (error) {
            }
          }
        }
      } else {
        this[type + "List"] && this[type + "List"].map((item) => {
          if (item.key === key) {
            item.status = targetStatus;
            item.fileId = fileId;
            item.preImg = preImg;
          }
          return item;
        });
      }
    },
    dsBridgeUploadImageToServer(actionUrl, uploadData, dataParams) {
      const { key, type } = dataParams;
      dsBridgeUploadImageToServerApi(actionUrl, {}, uploadData).then(
        res => {
          try {
            res = JSON.parse(res);
            if (res && res.data && res.code == "0000") {
              let obj = {
                fileId: null,
                preImg: "",
                key,
                type,
              };
              obj.fileId = res.data.id;
              obj.preImg = res.data.url;
              if (type === "params") {
                const paramsIndex = this.commitIdList.findIndex(
                  (item) => item.type === type
                );
                if (paramsIndex > -1) {
                  this.commitIdList[paramsIndex].children.push(obj);
                } else {
                  this.commitIdList.push({
                    type,
                    children: [obj],
                  });
                }
              } else {
                this.commitIdList.push({
                  key,
                  type,
                  fileId: obj.fileId,
                });
              }
              // debugger
              this.handleRequestStatus(key, type, 2, obj);
              // delete this.cacheFileObj[key];
            } else {
              this.handleRequestStatus(key, type, 3);
            }
          } catch (error) {
            this.handleRequestStatus(key, type, 3);
          }
        });
    },
    // 上传图片 到阿里云
    uploadImgApi(file, actionUrl, uploadData, dataParams, uploadCallback) {
      // debugger
      const { key, type } = dataParams;
      let formData = new FormData();
      formData.append("name", uploadData.name);
      formData.append("x-oss-object-acl", uploadData["x-oss-object-acl"]);
      formData.append("key", uploadData.key);
      formData.append("policy", uploadData.policy);
      formData.append("OSSAccessKeyId", uploadData.OSSAccessKeyId);
      formData.append(
        "success_action_status",
        uploadData.success_action_status
      );
      formData.append("callback", uploadData.callback);
      formData.append("signature", uploadData.signature);
      formData.append("file", file);
      // debugger
      uploadImg(actionUrl, formData)
        .then((res) => {
          let { code, data } = res
          // debugger
          if (code === "0000") {
            let obj = {
              fileId: null,
              preImg: "",
              key,
              type,
            };
            obj.fileId = data.id;
            obj.preImg = data.url;
            this.url = data.url
            this.$emit('changeImeiPhoto', data.url)
            if (type === "params") {
              const paramsIndex = this.commitIdList.findIndex(
                (item) => item.type === type
              );
              if (paramsIndex > -1) {
                this.commitIdList[paramsIndex].children.push(obj);
              } else {
                this.commitIdList.push({
                  type,
                  children: [obj],
                });
              }
            } else {
              this.commitIdList.push({
                key,
                type,
                fileId: obj.fileId,
              });
            }
            // debugger
            this.handleRequestStatus(key, type, 2, obj);
            // localStorage.removeItem(key);
            uploadCallback && uploadCallback(true)
            // delete this.cacheFileObj[key];
          } else {
            // 上传失败
            this.handleRequestStatus(key, type, 3);
            uploadCallback && uploadCallback(false)
          }
        })
        .catch(() => {
          this.handleRequestStatus(key, type, 3);
          uploadCallback && uploadCallback(false)
        });
    },
  }
};
</script>

<style scoped lang='less'>
.address-info {
  width: 100%;
  box-sizing: border-box;
  color: #fff;
  margin-bottom: 24px;
  background: #fff;
  border-radius: 20px;
  padding: 0 24px 24px;
  .title {
    height: 84px;
    font-size: 32px;
    font-weight: 500;
    color: #333;
    line-height: 84px;
  }
  .item {
    padding: 30px 0px 29px 0px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #F4F5F7;
    position: relative;
    .item-left {
      width: 170px;
      font-size: 28px;
      color: #5D5F65;
      margin-right: 32px;
    }
    .item-right {
      flex: 1;
      color: #333;
      input {
        border: none;
        padding: 0;
      }
      input::placeholder {
        color: #999;
        font-size: 28px;
      }
      .error-tip {
        color: #F00;
        font-size: 24px;
        position: absolute;
        bottom: 0;
      }
      .input {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .btn {
          padding: 12px;
          color: #fff;
          background: #FF9600;
          font-size: 24px;
          border-radius: 10px;
        }
      }
    }
  }
  .item:last-child {
    border-bottom: none;
  }
}
</style>
